var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconDash24(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 11.4999C4.72386 11.4999 4.5 11.7238 4.5 11.9999C4.5 12.2761 4.72386 12.4999 5 12.4999H19C19.2761 12.4999 19.5 12.2761 19.5 11.9999C19.5 11.7238 19.2761 11.4999 19 11.4999H5Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDash24);
export default __webpack_public_path__ + "static/media/icon-dash-24.2e8a1cb2.svg";
export { ForwardRef as ReactComponent };